export const TIP_SHEET_TYPES = [
	{
		name: "Informational",
		description: "A discussion about a topic with expert testimony. No bill considered."
	},
	{
		name: "Pre-Hearing",
		description: "A preview of an upcoming bill discussion."
	},
	{
		name: "Awaiting Transcription",
		description: "A pre-hearing waiting to be processed into a full tipsheet."
	},
	{
		name: "Committee Vote",
		description: "A bill discussion and vote in a committee hearing."
	},
	{
		name: "Floor Vote",
		description: "A bill discussion and vote on the Assembly or Senate floor."
	},
	{
		name: "Floor Discussion",
		description: "Discussion only. No bill or vote."
	},
	{
		name: "Governor's Veto",
		description: "A veto of a bill by the governor."
	}
]
